import styled, { css } from 'styled-components';
import { layout, remCalc, media } from '@prisjakt/ui-base';
import { H3Text } from '@prisjakt/ui/text/variants';
import UserReviewCardComponent from '../../components/user-review-card';

export const InfoLink = styled.div`
  cursor: pointer;
  color: ${p => p.theme.text.callToAction};
  text-align: center;
  line-height: 1.5;

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
    text-decoration: underline;
  }

  a {
    display: flex;
    align-items: center;
    column-gap: ${layout.measurements.spacing025};
  }

  a,
  a:hover {
    color: inherit;
  }
`;

export const OldReviewsHeader = styled.div`
  padding-top: ${layout.margins.wrapper.desktop.rem};
  border-top: 1px solid ${p => p.theme.lines.primary};
  margin-top: ${layout.margins.component.desktop.rem};

  ${media.mediumDown`
    padding-top: ${layout.margins.wrapper.mobile.rem};
    margin-top: ${layout.margins.component.mobile.rem};
  `}
`;

export const SortedBy = styled.div`
  display: flex;
  justify-content: flex-end;
  color: ${p => p.theme.text.tertiary};
  font-size: ${remCalc(12)};
`;

export const EditButton = styled.button`
  cursor: pointer;
  color: ${p => p.theme.text.callToAction};

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

type UserReviewCardProps = {
  fullWidth?: boolean;
};

export const UserReviewCard = styled(UserReviewCardComponent)<
  UserReviewCardProps
>(
  p => css`
    grid-template-columns: 0 3fr 1fr;

    ${p.fullWidth &&
      css`
        grid-template-columns: 0 1fr 0;
      `};
  `
);

export const ExpertReviews = styled.div`
  margin-bottom: ${layout.measurements.spacing300};
`;

export const PanelTitle = styled(H3Text)`
  margin: 0;
`;
